import React from 'react';

export function Recommend() {
  const handleShare = () => {
    const shareText = encodeURIComponent(
      'Sandra | Estética y Quiromasaje para mujeres en Paterna\n' +
      'https://sandraestetica.app'
    );
    window.open(`https://api.whatsapp.com/send?text=${shareText}`, '_blank');
  };

  return (
    <div className="space-y-4">
      <div className="bg-primary rounded-lg p-4 text-center h-[50px] flex items-center justify-center">
        <h1 className="text-xl text-white">RECOMIÉNDAME</h1>
      </div>
      
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl text-primary text-center mb-6">COMPARTIR TIENE PREMIO</h2>
        
        <p className="text-gray-600 mb-6">
          Así es. Si recomiendas mis servicios a una amiga y ésta viene de tu parte, tendrás un 10% de descuento para gastar en tu próxima visita.
        </p>
        
        <p className="text-gray-600 mb-6">
          Pulsa en el siguiente botón para recomendar mis servicios a quien tú quieras.
        </p>
        
        <div className="space-y-3">
          <p className="text-sm text-gray-500 italic text-center mb-4">
            Descuento válido durante 3 meses
          </p>
          <button 
            onClick={handleShare}
            className="block w-full bg-primary text-white text-center px-4 py-1.5 rounded-full hover:bg-primary/90 transition-colors"
          >
            Recomendar
          </button>
        </div>
      </div>
    </div>
  );
}